
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useIsMobile } from '@/hooks/use-mobile';

const SubpageNavigation: React.FC = () => {
  const location = useLocation();
  const isMobile = useIsMobile();
  
  const navItems = [
    { path: '/', label: 'Overview', exact: true },
    { path: '/pomodoro', label: 'Pomodoro' },
    { path: '/kanban', label: 'Kanban' },
    { path: '/eisenhower', label: 'Matrix' }
  ];

  const isActive = (path: string, exact = false) => {
    if (exact) {
      return location.pathname === path;
    }
    return location.pathname === path;
  };

  return (
    <nav className="mb-8" role="tablist" aria-label="Content navigation">
      <div className="bg-gray-100 dark:bg-gray-800 rounded-xl p-1 flex w-full gap-1">
        {navItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            role="tab"
            aria-selected={isActive(item.path, item.exact)}
            className={`
              flex-1 flex-shrink-0 px-3 py-2 text-sm rounded-lg font-medium text-center
              leading-5 flex items-center justify-center box-border
              hover:bg-white/50 dark:hover:bg-gray-700/50
              focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-100 dark:focus:ring-offset-gray-800
              transition-all duration-200 ease-in-out
              ${isActive(item.path, item.exact)
                ? 'bg-white dark:bg-gray-700 text-gray-900 dark:text-white'
                : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
              }
            `}
          >
            {item.label}
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default SubpageNavigation;
